import addDays from "date-fns/addDays";
import format from "date-fns/format";
const dateRegex = /^[01][0-9]\/[0-3][0-9]\/\d{4}$/;
export function parseDate(value) {
    if (value && value.length === 8) {
        return new Date(+value.substring(0, 4), (+value.substring(4, 6) - 1), +value.substring(6, 8));
    }
    return null;
}
export function getCurrentDate() {
    const date = new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
export function TwoDigitFormat(num) {
    const digits = "00";
    const numStr = `${digits}${num || ""}`;
    return numStr.substring(numStr.length - 2);
}
export function formatdate(value) {
    return `${value.getFullYear()}${TwoDigitFormat(value.getMonth() + 1)}${TwoDigitFormat(value.getDate())}`;
}
export function dateAddDays(date, amount) {
    return addDays(date, amount);
}
export function getStartDate(minDays, hasParent, dependentDateValue) {
    if (hasParent && dependentDateValue) {
        return dependentDateValue;
    }
    const date = new Date(getCurrentDate());
    if (typeof minDays === 'number' && !isNaN(minDays)) {
        date.setDate(date.getDate() + minDays);
    }
    else {
        date.setFullYear(date.getFullYear() - 100);
    }
    return date;
}
export function getEndDate(maxDays, parentDate, parentDependentDays, hasChild, childDate) {
    if (parentDate && parentDependentDays) {
        return addDays(parentDate, parentDependentDays);
    }
    const maxDate = new Date(getCurrentDate());
    if (typeof maxDays === 'number' && !isNaN(maxDays)) {
        maxDate.setDate(maxDate.getDate() + maxDays);
    }
    else {
        maxDate.setFullYear(maxDate.getFullYear() + 100);
    }
    if (hasChild && childDate) {
        return (maxDate < childDate ? maxDate : childDate);
    }
    return maxDate;
}
/**
 * @param value - Date string with format MM/dd/yyyy
 * @returns date
 */
export function parseInputDate(value) {
    if (!dateRegex.test(value)) {
        return null;
    }
    const dateParts = value.split("/");
    /** Javascript date 0 - Jan, 11 - Dec */
    const month = +dateParts[0] - 1;
    if (month < 0 || month > 11) {
        return null;
    }
    const day = +dateParts[1];
    const year = +dateParts[2];
    const date = new Date(year, month, day);
    /**
     * Javascript Date constructor accepts month and date beyond Range
     */
    if (date.getDate() !== day && month !== date.getMonth()) {
        return null;
    }
    return date;
}
export function commonDateValidations(date, isRequired, minDate, maxDate) {
    let error = "";
    if (!date && isRequired) {
        error = 'The field is required and must not be blank, and must follow the MM/DD/YYYY format.';
    }
    if (date && minDate && date < minDate) {
        error = `Selected date should be after ${format(minDate, 'MM/dd/yyyy')}`;
    }
    if (date && maxDate && format(date, 'yyyyMMdd') > format(maxDate, 'yyyyMMdd')) {
        error = `Selected date should be on or before ${format(maxDate, 'MM/dd/yyyy')}`;
    }
    return error;
}
export function commonDateFieldValidation(dateString, isRequired) {
    let error = "";
    if (dateString.length === 0 && isRequired) {
        error = "The field is required and must not be blank, and must follow the MM/DD/YYYY format.";
    }
    if (dateString.length > 0 && dateString.length < 10) {
        error = "Invalid date!, Date of birth should not be less than 8 characters and it should follow the format MM/DD/YYYY.";
    }
    return error;
}
